(function () {
  'use strict';

  function initFontPreviewDialog() {
    const openBtn = document.querySelector('[data-font-preview-open]');
    const closeBtn = document.querySelector('[data-font-preview-close]');
    const dialog = document.querySelector('[data-font-preview-dialog]');
    if (!openBtn || !dialog) return;

    openBtn.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', 'open');
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  function initFontPreview(root) {
    const input = root.querySelector('.la-font-preview__input');
    const previews = root.querySelectorAll('[data-font-preview-option-text]');
    if (!input || !previews.length) return;

    function updatePreviews() {
      previews.forEach(function (preview) {
        preview.textContent = input.value;
      });
    }

    input.addEventListener('input', updatePreviews);
  }

  // Die BuyBox-Platzierung des Triggers (direkt unter "Schritt 2
  // Personalisierung", vor Globos Feldern) uebernimmt la-pdp-globo.js als
  // Teil seiner Schritt-Reihenfolge-Korrektur — hier nur Oeffnen/Schliessen
  // und die Schriftauswahl selbst.
  initFontPreviewDialog();

  document.querySelectorAll('.la-font-preview').forEach(initFontPreview);
})();
